import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SOFT = [
  {
    quote: "I was about to go ahead with the work, but the review flagged things I hadn't even considered. Glad I checked first.",
    name: "Park Home Owner",
  },
  {
    quote: "It gave me confidence to question the quote properly instead of just accepting it.",
    name: "Resident",
  },
  {
    quote: "Made me realise there was more to consider before committing. Worth doing first.",
    name: "Park Home Owner",
  },
];

export default function Testimonials() {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/reviews/approved`)
      .then((r) => {
        if (!mounted) return;
        const list = r.data?.reviews || [];
        // Use real reviews only when at least 3 are approved — until then keep soft proof
        if (list.length >= 3) setReviews(list.slice(0, 3));
        else setReviews([]);
      })
      .catch(() => mounted && setReviews([]));
    return () => {
      mounted = false;
    };
  }, []);

  const items =
    reviews && reviews.length >= 3
      ? reviews.map((r) => ({
          quote: r.comment,
          name: r.first_name + (r.location ? ` · ${r.location}` : ""),
        }))
      : SOFT;

  return (
    <section className="section-pad bg-white" data-testid="testimonials-section">
      <div className="container-phs">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow">What Owners Say</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-tight text-[#071A33]">
            What People Say After Getting a Quote Checked.
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {items.map((t, i) => (
            <div
              key={i}
              className="rounded-3xl border border-[#E2E8F0] p-7 bg-white shadow-sm hover:shadow-md transition-shadow"
              data-testid={`testimonial-${i}`}
            >
              <p className="text-[#475569] leading-relaxed text-[15px]">
                <span className="font-display text-3xl text-[#B88A2A] leading-none align-top mr-1">&ldquo;</span>
                {t.quote}
              </p>
              <p className="mt-5 text-sm text-[#94A3B8] tracking-wide">— {t.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
